/* eslint-disable custom/no-hardcoded-colors */
import { withOnClickTracking } from 'auto-tracking';
import {
  ButtonGroup,
  Icon,
  rem,
  SkeletonLoader,
  Spinner,
  styled,
  theme,
} from 'design-system';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { UploadButtonNew } from 'preflight-core';
import { useEffect, useRef, useState } from 'react';

import { useEventTracking } from '../../../contexts/tracking-context';
import { Check, getJournal, Journal } from '../../../resources/journal';
import { defaultPublisherSlugMapping } from '../../../utils/endpoint-v1-default-journal';
import {
  getAllJournalSlugsForEndpointResType,
  journalObjectType,
} from '../../../utils/get-Journal-list-endpoint-v1';
import { mutateString } from '../../../utils/replace-language';
import { mapJournalToVariant } from '../../journal-variant';
import { CustomFontHeaderContainer } from '../../section';

export const Section1HomepageLHS = ({
  languageCheckLists,
  technicalCheckLists,
  journal,
  onFileSelected,
  uploadState,
  showQuickView,
  setErrorScreen,
  errorSection,
  setErrorSection,
  setOtherSectionClicked,
  techCheckCount,
  langCheckCount,
  fetchJournalsForEndpointApi,
  journalList,
  publisherSlug,
  selectedJournal,
  setSelectedJournal,
  setIsLoadingJournalList,
  tempJournalDetails,
  setTempJournalDetails,
  selectedPaymentCurrency,

  isLoadingJournalList,
}: {
  journal: Journal;
  languageCheckLists: Check[];
  technicalCheckLists: Check[];

  onFileSelected: (file: File) => void;
  uploadState: { name: string };
  showQuickView: boolean;
  setErrorScreen: (value: boolean) => void;
  errorSection: string;
  setErrorSection: (value: string) => void;
  setOtherSectionClicked: (value: boolean) => void;
  techCheckCount: number;
  langCheckCount: number;
  fetchJournalsForEndpointApi: (data: {
    publisherSlug: string;
    journalSlug: string;
  }) => void;
  journalList: getAllJournalSlugsForEndpointResType;
  publisherSlug: string;
  selectedJournal: journalObjectType;
  setSelectedJournal: (data: journalObjectType) => void;
  isLoadingJournalList: boolean;
  setIsLoadingJournalList: (data: boolean) => void;

  tempJournalDetails: Journal | undefined;
  setTempJournalDetails: (data: Journal | undefined) => void;
  selectedPaymentCurrency: string | undefined;

  buttonDisabled: boolean;
}) => {
  const t = useTranslation('homepage').t;
  const { trackEvent } = useEventTracking();

  const mappedJournal = mapJournalToVariant(journal.publisher.slug);
  const [showTooltip2, setShowTooltip2] = useState(false);
  const [showTooltip3, setShowTooltip3] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const handleMouseEnter2 = () => {
    setShowTooltip2(true);
  };
  const handleMouseLeave2 = () => {
    setShowTooltip2(false);
  };
  const handleMouseEnter3 = () => {
    setShowTooltip3(true);
  };
  const handleMouseLeave3 = () => {
    setTimeout(() => {
      if (!tooltipRef.current?.matches(':hover')) {
        setShowTooltip3(false);
      }
    }, 100);
  };
  const handleTooltipMouseEnter = () => {
    setShowTooltip3(true);
  };

  const handleTooltipMouseLeave = () => {
    setShowTooltip3(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      tooltipRef.current &&
      !tooltipRef.current.contains(event.target as Node)
    ) {
      setShowTooltip3(false);
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const [inputFileName, setInputFileName] = useState('');
  const [error, setError] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleToggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const [dropdownPosition, setDropdownPosition] = useState<
    | 'above'
    | 'closeAbove'
    | 'below'
    | 'closeToLeft'
    | 'closeToRight'
    | 'closeToTop'
    | 'closeToBottom'
  >('below');

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
        setInputFileName('');
        setFileName('');
        setError('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const updateDropdownPosition = () => {
      if (!dropdownRef.current) {
        return;
      }

      const dropdownTriggerRect = dropdownRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const scrollY = window.scrollY;

      const spaceAbove = dropdownTriggerRect.top + scrollY;
      const spaceBelow = viewportHeight - dropdownTriggerRect.bottom;

      if (spaceBelow < 100) {
        setDropdownPosition('closeToBottom');
      } else if (spaceBelow < 250) {
        setDropdownPosition('closeAbove');
      } else if (spaceAbove > 250 && spaceBelow > 250) {
        setDropdownPosition('below');
      } else if (spaceAbove < 100) {
        setDropdownPosition('closeToTop');
      }
    };

    window.addEventListener('scroll', updateDropdownPosition);
    window.addEventListener('resize', updateDropdownPosition);

    updateDropdownPosition();

    return () => {
      window.removeEventListener('scroll', updateDropdownPosition);
      window.removeEventListener('resize', updateDropdownPosition);
    };
  }, []);

  const [isFocused, setIsFocused] = useState(false);
  const [fileName, setFileName] = useState('');

  const [journalLoader, setJournalLoader] = useState(false);

  const getJournalInfo = async (journalSlug: string) => {
    if (tempJournalDetails?.slug === journalSlug) {
      return;
    }
    setJournalLoader(true);
    const res = await getJournal({
      journalSlug: journalSlug,
      publisherSlug: publisherSlug,
      currency: selectedPaymentCurrency,
    });

    setTimeout(() => {
      setJournalLoader(false);
    }, 1000);

    setTempJournalDetails(res);

    return res;
  };

  useEffect(() => {
    if (selectedJournal.slug !== tempJournalDetails?.slug) {
      setJournalLoader(true);
      setTempJournalDetails(undefined);

      setTimeout(() => {
        getJournalInfo(selectedJournal.slug).then(() => {
          setJournalLoader(false);
        });
      }, 1000);
    }
  }, [selectedJournal]);

  useEffect(() => {
    fetchJournalsForEndpointApi({ publisherSlug, journalSlug: fileName });
    setIsLoadingJournalList(true);
  }, [fileName]);

  useEffect(() => {
    const fetchAndSetJournals = async () => {
      await fetchJournalsForEndpointApi({
        publisherSlug,
        journalSlug: fileName,
      });
      setJournalLoader(false);
      setIsLoadingJournalList(false);
    };

    if (fileName) {
      fetchAndSetJournals();
    }
  }, [fileName]);

  const handleSearch = () => {
    if (inputFileName.length === 0) {
      setFileName('');
      setError('');
    } else if (inputFileName.length < 3) {
      setError('Please enter at least 3 characters');
    } else {
      setFileName(inputFileName);
      setError('');
    }
  };

  const getBorderColor = () => {
    if (error && isFocused) {
      return theme.colors.red10;
    }
    if (isFocused) {
      return theme.colors.blue9;
    }
    return theme.colors.gray8;
  };

  return (
    <>
      <MainSection>
        <>
          <CustomFontHeaderContainer journal={mappedJournal}>
            <MainHeading style={{ fontSize: '28px' }}>
              {journal.publisher.slug === 'endnote'
                ? 'From EndNote to Submission:'
                : journal.publisher.slug === 'refworks'
                ? 'From RefWorks to Submission:'
                : journal.publisher.slug === 'endnote-fusion'
                ? 'From EndNote Fusion to Submission:'
                : null}
              <br />
              Preflight Refines Manuscripts in Minutes
            </MainHeading>
          </CustomFontHeaderContainer>
          <SubHeadingNew
            variant={journal.publisher.slug === 'bmj' ? 'nonItalic' : 'default'}
            style={{
              fontSize: journal.publisher.slug === 'aipp' ? '45px' : '18px',
            }}
            aria-label={`${journal.publisher.label} / ${journal.label}`}
            data-test-id="journal-heading"
          >
            Preflight helps you identify and resolve issues with technical
            compliance and language quality in your manuscript.
          </SubHeadingNew>
          <SubHeadingNew2>
            {t(
              'section1_v2.assessment_checks_recommended',
              'Assessment checks recommended by your journal:',
            )}
          </SubHeadingNew2>

          {journalLoader ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}
            >
              <SkeletonLoader
                height="27px"
                width="35%"
                background={theme.colors.gray5.value}
              />
              <SkeletonLoader
                height="27px"
                width="45%"
                background={theme.colors.gray5.value}
              />
            </div>
          ) : (
            <TextDefault2 style={{ marginTop: '6px' }}>
              {techCheckCount > 0 && langCheckCount > 0 ? (
                <>
                  <LangTechEvaluations>
                    <Image
                      width={16}
                      height={22}
                      src="/green-new-tick.svg"
                      alt="Green Tick"
                      style={{
                        display: 'inline',
                        marginRight: '8px',
                        verticalAlign: 'middle',
                      }}
                    />
                    <span
                      data-test-id="language-check-count"
                      style={{
                        fontWeight: 'bold',
                        paddingRight: '4px',
                        cursor: 'pointer',
                        color: showTooltip2
                          ? theme.colors.blue10.value
                          : 'inherit',
                      }}
                      onMouseEnter={() => handleMouseEnter2()}
                      onMouseLeave={() => handleMouseLeave2()}
                    >
                      {langCheckCount}
                    </span>
                    {mutateString(
                      t('section1_v1.is_manuscript_ready_description.lang'),
                      {},
                    )}
                  </LangTechEvaluations>
                  {showTooltip2 ? (
                    <TooltipNew>
                      <ExpandableTextUL>
                        {languageCheckLists.map((check, index) => (
                          <ExpandableTextLI key={index}>
                            <span>{check.label}</span>
                          </ExpandableTextLI>
                        ))}
                      </ExpandableTextUL>
                    </TooltipNew>
                  ) : (
                    <></>
                  )}

                  <LangTechEvaluations>
                    <Image
                      width={16}
                      height={22}
                      src="/green-new-tick.svg"
                      alt="Green Tick"
                      style={{
                        display: 'inline',
                        marginRight: '8px',
                        verticalAlign: 'middle',
                      }}
                    />
                    <span
                      data-test-id="technical-check-count"
                      style={{
                        fontWeight: 'bold',
                        paddingRight: '4px',
                        cursor: 'pointer',
                        color: showTooltip3
                          ? theme.colors.blue10.value
                          : 'inherit',
                      }}
                      onMouseEnter={() => handleMouseEnter3()}
                      onMouseLeave={() => handleMouseLeave3()}
                    >
                      {techCheckCount}
                    </span>
                    {mutateString(
                      t('section1_v1.is_manuscript_ready_description.tech'),
                      {},
                    )}
                  </LangTechEvaluations>
                  {showTooltip3 ? (
                    <TooltipNew2
                      ref={tooltipRef}
                      onMouseEnter={handleTooltipMouseEnter}
                      onMouseLeave={handleTooltipMouseLeave}
                    >
                      <ExpandableTextUL>
                        {technicalCheckLists.map((check, index) => (
                          <ExpandableTextLI key={index}>
                            <span>{check.label}</span>
                          </ExpandableTextLI>
                        ))}
                      </ExpandableTextUL>
                    </TooltipNew2>
                  ) : (
                    <></>
                  )}
                </>
              ) : techCheckCount > 0 ? (
                <>
                  <LangTechEvaluations>
                    <Image
                      width={16}
                      height={22}
                      src="/green-new-tick.svg"
                      alt="Green Tick"
                      style={{
                        display: 'inline',
                        marginRight: '8px',
                        verticalAlign: 'middle',
                      }}
                    />
                    <span
                      data-test-id="technical-check-count"
                      style={{
                        fontWeight: 'bold',
                        paddingRight: '4px',
                        cursor: 'pointer',
                        color: showTooltip3
                          ? theme.colors.blue10.value
                          : 'inherit',
                      }}
                      onMouseEnter={() => handleMouseEnter3()}
                      onMouseLeave={() => handleMouseLeave3()}
                    >
                      {techCheckCount}
                    </span>
                    {mutateString(
                      t('section1_v1.is_manuscript_ready_description.tech'),
                      {},
                    )}
                  </LangTechEvaluations>
                  {showTooltip3 ? (
                    <TooltipNew2
                      ref={tooltipRef}
                      onMouseEnter={handleTooltipMouseEnter}
                      onMouseLeave={handleTooltipMouseLeave}
                    >
                      <ExpandableTextUL>
                        {technicalCheckLists.map((check, index) => (
                          <ExpandableTextLI key={index}>
                            <span>{check.label}</span>
                          </ExpandableTextLI>
                        ))}
                      </ExpandableTextUL>
                    </TooltipNew2>
                  ) : (
                    <></>
                  )}
                </>
              ) : langCheckCount > 0 ? (
                <>
                  <LangTechEvaluations>
                    <Image
                      width={16}
                      height={22}
                      src="/green-new-tick.svg"
                      alt="Green Tick"
                      style={{
                        display: 'inline',
                        marginRight: '8px',
                        verticalAlign: 'middle',
                      }}
                    />
                    <span
                      data-test-id="language-check-count"
                      style={{
                        fontWeight: 'bold',
                        paddingRight: '4px',
                        cursor: 'pointer',
                        color: showTooltip2
                          ? theme.colors.blue10.value
                          : 'inherit',
                      }}
                      onMouseEnter={() => handleMouseEnter2()}
                      onMouseLeave={() => handleMouseLeave2()}
                    >
                      {langCheckCount}
                    </span>
                    {mutateString(
                      t('section1_v1.is_manuscript_ready_description.lang'),
                      {},
                    )}
                  </LangTechEvaluations>
                  {showTooltip2 ? (
                    <TooltipNew>
                      <ExpandableTextUL>
                        {languageCheckLists.map((check, index) => (
                          <ExpandableTextLI key={index}>
                            <span>{check.label}</span>
                          </ExpandableTextLI>
                        ))}
                      </ExpandableTextUL>
                    </TooltipNew>
                  ) : (
                    <></>
                  )}
                </>
              ) : null}
            </TextDefault2>
          )}
          {/* {journal.articleTypes?.length === 1 ? (
                <TextDefault>
                  <></>
                </TextDefault>
              ) : ( */}

          {/* )} */}
        </>
        <ButtonGroup
          style={{ marginTop: '28px', display: 'flex', gap: '12px' }}
        >
          <ButtonWrap>
            <UploadButtonNew
              id="Run-Pre-Submission Checks-Free"
              disabled={
                !showQuickView &&
                (uploadState.name === 'loading' ||
                  uploadState.name === 'success')
              }
              onClick={() => {
                trackEvent([
                  'Manuscript upload intent',
                  'Upload click',
                  'Run pre-submission checks Free',
                  {
                    Section: 'Section 1',
                  },
                ]);
                setOtherSectionClicked(false);
                if (errorSection !== 'Section_1' && errorSection !== '') {
                  setOtherSectionClicked(true);
                  setErrorScreen(false);
                }
                setErrorSection('Section_1');
              }}
              onFileSelected={onFileSelected}
              size="small"
              text={t('section1_v2.upload_for_free_assessment')}
              isIcon={true}
              isHoverPrimary={true}
              style={{
                fontSize: '20px',
              }}
              optionalLanguageText={{
                processing: t('common.processing'),
              }}
              trackingProperties={{
                CTALabel: 'Upload for free assessment',
                elementName: 'manuscript_upload',
                sectionName: 'section_1',
              }}
              isAIPP={journal.publisher.slug === 'aipp' ? true : false}
            />
          </ButtonWrap>
        </ButtonGroup>

        <FormatAccepted
          aria-label="Formats accepted"
          data-test-id="formats-accepted"
        >
          {t('section1_v1.formats_accepted', 'Formats accepted')}
          <Image
            width={36}
            height={36}
            src="/pdf-word-group.svg"
            alt={journal.label}
            style={{
              display: 'inline',
              marginLeft: '5px',
              marginRight: '5px',
            }}
          />
          {t('section1_v1.size_accepted', 'Size accepted')}
        </FormatAccepted>

        <div>
          <DropdownContainer ref={dropdownRef}>
            <SelectArticleTypeContainer data-test-id="select-article-type">
              <MainHeading2>
                {t(
                  'section1_v2.select_article_typ',
                  'Search for custom configuration:',
                )}
              </MainHeading2>

              <SelectedContainerSub>
                <SelectedOption
                  data-test-id="selected-option-atc"
                  onClick={handleToggleDropdown}
                  aria-label="Selected article type"
                  role="button"
                >
                  {t('common.type_to_searc', 'Configure')}
                </SelectedOption>

                <ToggleDropdown
                  onClick={handleToggleDropdown}
                  aria-label="Toggle dropdown"
                  role="button"
                  data-test-id="toggle-dropdown"
                >
                  <span style={{ width: '20px' }}>
                    <Icon
                      variant={'regular'}
                      name={isOpen ? 'chevronDown' : 'ChevronRight'}
                      size="1x"
                    />
                  </span>
                </ToggleDropdown>
              </SelectedContainerSub>
            </SelectArticleTypeContainer>

            {isOpen && (
              <div
                style={{
                  position: 'absolute',
                  display: 'flex',
                  zIndex: 1,
                  left:
                    dropdownPosition === 'closeAbove'
                      ? 'calc(49% - 260px)'
                      : dropdownPosition === 'closeToBottom'
                      ? 'calc(50% - 250px)'
                      : 'calc(50% - 360px)',

                  top:
                    dropdownPosition === 'closeAbove'
                      ? 'calc(60% - 20px)' // Adjust closer to the top
                      : dropdownPosition === 'closeToBottom'
                      ? 'calc(60% - 100px)' // Adjust slightly above
                      : '',

                  backgroundColor: theme.colors.white.value,
                  border: '1px solid rgba(188, 199, 220, 1)',
                  borderRadius: '8px',
                  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                }}
              >
                <div style={{ padding: '15px' }}>
                  <div
                    style={{
                      position: 'relative',
                      backgroundColor: 'rgba(244, 244, 244, 1)',
                      borderRadius: '10px',
                    }}
                  >
                    <Search
                      placeholder={t(
                        `section1_v1.please_enter_to_search_${publisherSlug}`,
                        'Type journal name and press enter to search',
                      )}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearch();
                        }
                      }}
                      value={inputFileName}
                      onChange={(e) => {
                        setInputFileName(e.target.value);
                        setError('');
                      }}
                      style={{
                        backgroundColor: theme.colors.white.value,
                        color: isFocused ? 'black' : theme.colors.gray8.value,
                        border: `1px solid ${getBorderColor()}`,
                      }}
                      id="search_for_file_name"
                      data-test-id={`dashboard-search-for-file-name`}
                      type="text"
                      aria-label="Search for journal name"
                    />
                    <div
                      onClick={handleSearch}
                      style={{
                        position: 'absolute',
                        right: '0.6px',
                        top: inputFileName.length !== 0 ? '28%' : '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor:
                          inputFileName.length > 0
                            ? theme.colors.blue10.value
                            : '#0062FF1A',
                        width: '40px',
                        height: '39.5px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                        borderTopRightRadius: '5px',
                        borderBottomRightRadius: '5px',
                      }}
                    >
                      <div
                        style={{
                          color:
                            inputFileName.length > 0
                              ? theme.colors.white.value
                              : theme.colors.gray8.value,
                        }}
                      >
                        <Icon name="search" size="sm" variant={'regular'} />
                      </div>
                    </div>
                    {inputFileName.length !== 0 && (
                      <div
                        style={{
                          backgroundColor: 'rgba(244, 244, 244, 1)',
                          color: 'rgba(93, 106, 129, 1)',
                          padding: '8px 12px',
                          borderBottomLeftRadius: '10px',
                          borderBottomRightRadius: '10px',
                          fontSize: '12px',
                          textAlign: 'center',
                        }}
                      >
                        {t(
                          `section1_v1.please_enter_to_search_${publisherSlug}`,
                          'Type journal name and press enter to search',
                        )}
                      </div>
                    )}
                  </div>
                  {isLoadingJournalList ? (
                    <div
                      style={{
                        display: 'flex',
                        width: '380px',
                        height: '217px',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Spinner size={24} />
                    </div>
                  ) : (
                    journalList?.journals?.length > 0 && (
                      <JournalList>
                        {journalList?.journals.map(
                          (each: journalObjectType) => {
                            return (
                              <JournalListItem
                                key={each.id}
                                onClick={() => {
                                  setTempJournalDetails(undefined);
                                  setSelectedJournal(each);

                                  setInputFileName('');
                                  setFileName('');
                                  setIsOpen(false);
                                }}
                                style={
                                  selectedJournal?.id === each.id
                                    ? {
                                        backgroundColor:
                                          'rgba(217, 229, 253, 1)',
                                        color: `rgba(0, 84, 241, 1)`,
                                      }
                                    : {}
                                }
                                aria-label={`Journal ${each.label}`}
                              >
                                <span
                                  style={{
                                    width: '94%',
                                    fontSize: '14px',
                                    lineHeight: '24px',
                                    fontWeight: 500,
                                  }}
                                >
                                  {each.label}
                                </span>
                                {selectedJournal?.id === each.id && (
                                  <span>
                                    <Icon name={'check'} variant={'solid'} />
                                  </span>
                                )}
                              </JournalListItem>
                            );
                          },
                        )}
                      </JournalList>
                    )
                  )}

                  {!journalList?.journals?.length && !isLoadingJournalList && (
                    <>
                      <div
                        style={{
                          width: '380px',
                          padding: '10px',
                          paddingLeft: '0px',
                          paddingRight: '0px',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <Heading2 style={{ textAlign: 'center' }}>
                            {t(
                              `section1_v1.sorry_no_results_were_foun_${publisherSlug}`,
                              `Sorry, no results were found`,
                            )}
                          </Heading2>
                          <Heading3 style={{ textAlign: 'center' }}>
                            {t(
                              `section1_v1.sorry_no_results_were_foun_${publisherSlug}`,
                              `You can search for another journal`,
                            )}
                          </Heading3>
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            marginTop: 18,
                            backgroundColor: 'rgba(237, 242, 250, 1)',
                            height: '130px',
                            padding: '10px',
                            width: '100%',
                            borderRadius: '6px',
                          }}
                        >
                          <div
                            style={{
                              color: theme.colors.blue12.value,
                              fontFamily: 'IBM Plex Sans',
                              fontWeight: 600,
                              fontSize: '14px',
                              lineHeight: '20px',
                              letterSpacing: '0%',
                              textAlign: 'left',
                            }}
                          >
                            Authors also preferred
                          </div>

                          <CheckDiv
                            onClick={async () => {
                              const journalSlug =
                                defaultPublisherSlugMapping?.[publisherSlug]
                                  ?.genericLang || '';
                              const fetchedJournalDetails =
                                await getJournalInfo(journalSlug);

                              if (!fetchedJournalDetails) {
                                return;
                              }

                              setSelectedJournal({
                                label: fetchedJournalDetails.label,
                                slug: fetchedJournalDetails.slug,
                                id: 0,
                              });

                              setInputFileName('');
                              setFileName('');
                              setIsOpen(false);
                            }}
                            style={{
                              backgroundColor: isLoadingJournalList
                                ? 'rgba(242, 247, 255, 1)'
                                : 'rgb(255, 255, 255)',
                              color: isLoadingJournalList
                                ? theme.colors.gray8.value
                                : theme.colors.blue11.value,
                              border: isLoadingJournalList
                                ? '1px solid rgba(188, 199, 220, 1)'
                                : '1px solid rgba(0, 98, 255, 1)',
                              cursor: isLoadingJournalList
                                ? 'not-allowed'
                                : 'pointer',
                            }}
                            onMouseEnter={(e: {
                              currentTarget: {
                                style: { backgroundColor: string };
                              };
                            }) => {
                              if (!isLoadingJournalList) {
                                e.currentTarget.style.backgroundColor =
                                  theme.colors.gray2.value;
                              }
                            }}
                            onMouseLeave={(e: {
                              currentTarget: {
                                style: { backgroundColor: string };
                              };
                            }) => {
                              if (!isLoadingJournalList) {
                                e.currentTarget.style.backgroundColor =
                                  'rgb(255, 255, 255)';
                              }
                            }}
                            aria-label="Detailed Language Check"
                          >
                            {journalLoader ? (
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  height: '34px',
                                }}
                              >
                                <Spinner size={16} />
                                <span style={{ marginLeft: '8px' }}>
                                  Fetching...
                                </span>
                              </div>
                            ) : (
                              <div>
                                {t(
                                  `section1_v1.detailed_language_chec_${publisherSlug}`,
                                  `Comprehensive Language check`,
                                )}
                              </div>
                            )}
                          </CheckDiv>

                          <div
                            style={{
                              fontFamily: 'IBM Plex Sans',
                              fontWeight: 400,
                              fontSize: '12px',
                              lineHeight: '18px',
                              letterSpacing: '0px',
                              color: '#5D6A81',
                              textAlign: 'left',
                            }}
                          >
                            This check ensures proper grammar, mechanics and
                            style, readability, vocabulary, clarity, and tone
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </DropdownContainer>
        </div>
      </MainSection>
    </>
  );
};

const MainSection = styled('div', {
  flex: 1,
  paddingTop: '10px',
});

const ButtonWrap = withOnClickTracking(
  styled('div', {
    minWidth: '300px',
    '& > Button': {
      minWidth: '300px',
      height: '60px',
    },
    '& > Button:hover': {
      backgroundColor: theme.colors.blue11,
    },
  }),
);

export const SectionTitle = styled('span', {
  display: 'flex',
  fontSize: '20px',
  color: theme.colors.blue11,
  fontWeight: 700,
  justifyContent: 'center',
  justifyItems: 'center',
  textTransform: 'uppercase',
});

export const SectionNewV1 = styled('div', {
  paddingTop: rem(48),
  paddingBottom: rem(80),
  background: theme.colors.white,
  paddingLeft: rem(32),
  paddingRight: rem(32),
  minWidth: rem(1234),
  variants: {
    size: {
      sm: {
        paddingTop: rem(40),
        paddingBottom: rem(40),
      },
      md: {
        paddingTop: rem(60),
        paddingBottom: rem(60),
      },
      lg: {
        paddingTop: rem(70),
        paddingBottom: rem(70),
      },
    },
    bgTheme: {
      gray: {
        background: theme.colors.gray2,
      },
      grayDark: {
        background: theme.colors.gray5,
      },
      yellow: {
        background:
          'linear-gradient(to top, rgba(249, 240, 209, 1), rgba(249, 240, 209, 0.5), rgba(249, 240, 209, 0))',
      },
      darkBlue: {
        background: 'rgba(5, 30, 87, 1)',
      },
      lightBlue1: {
        background: 'rgba(237, 243, 255, 1)',
      },
      lightBlue2: {
        background: 'rgba(225, 235, 255, 1)',
      },
      white: {
        background: 'rgba(255, 255, 255, 1)',
      },
    },
  },
});

const TextDefault2 = styled('div', {
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: '400',
  color: 'rgba(5, 30, 87, 1)',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
});

const SubHeadingNew = styled('div', {
  fontSize: '18px',
  lineHeight: '28px',
  fontWeight: '400',
  color: theme.colors.blue12,
  marginTop: '8px',
  paddingRight: '80px',
  position: 'relative',
  variants: {
    variant: {
      nonItalic: {
        fontStyle: 'normal',
      },
      default: {
        fontStyle: 'normal',
      },
    },
  },
});
const SubHeadingNew2 = styled('div', {
  fontSize: '18px',
  lineHeight: '24px',
  fontWeight: '600',
  color: '#051E57',
  marginTop: '22px',
  marginBottom: '4px',
});
const FormatAccepted = styled('div', {
  fontSize: '12px',
  lineHeight: '12px',
  fontWeight: '500',
  marginTop: '10px',
  color: theme.colors.gray11,
  display: 'flex',
  alignItems: 'center',
  marginBottom: '16px',
});
const LangTechEvaluations = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

const TooltipNew = styled('div', {
  position: 'absolute',
  backgroundColor: theme.colors.blue12,
  color: theme.colors.white,
  padding: '5px 10px',
  borderRadius: '4px',
  fontSize: '14px',
  height: 'max-content',
  fontFamily: 'IBM Plex Sans',
  textAlign: 'left',
  width: '168px',
  lineHeight: '22px',
  fontWeight: '400',
  fontStyle: 'normal',
  transform: 'translateY(10%)',
  marginTop: '8px',
});
const TooltipNew2 = styled('div', {
  position: 'absolute',
  transform: 'translateY(30%)',
  marginTop: '2px',
  backgroundColor: theme.colors.blue12,
  color: theme.colors.white,
  padding: '5px 10px',
  borderRadius: '4px',
  fontSize: '14px',
  height: 'max-content',
  fontFamily: 'IBM Plex Sans',
  textAlign: 'left',
  width: '368px',
  lineHeight: '22px',
  fontWeight: '400',
  fontStyle: 'normal',
  maxHeight: '200px',
  overflowY: 'auto',
  wordWrap: 'break-word',
  whiteSpace: 'normal',
  zIndex: 9999,
});
const ExpandableTextUL = styled('ul', {
  margin: 0,
  padding: '0',
});

const ExpandableTextLI = styled('li', {
  display: 'flex',

  fontSize: '12px',
  fontWeight: 400,
  color: theme.colors.white,
  margin: '10px 0',

  counterIncrement: 'list-item',
  '&::before': {
    content: 'counter(list-item) ". "',
    fontWeight: 'bold',
    marginRight: '10px',
  },
});
export const MainHeading = styled('span', {
  fontSize: '28px',
  lineHeight: '40px',
  fontWeight: '700',
  display: 'block',
  color: 'rgba(5, 30, 87, 1)',
  // textTransform: 'capitalize',
});
const MainHeading2 = styled('span', {
  fontSize: '14px',
  lineHeight: '40px',
  fontWeight: '500',
  display: 'block',
  color: '#5D6A81',
  // textTransform: 'capitalize',
});
const SelectedContainerSub = styled('div', {
  borderRadius: '16px',
  height: '32px',
  paddingLeft: '12px',
  paddingRight: '12px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});
const JournalListItem = withOnClickTracking(
  styled('div', {
    width: '98%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '10px',
    padding: '12px 10px',
    cursor: 'pointer',
    color: 'rgba(93, 106, 129, 1)',
    borderRadius: 6,
    '&:hover': {
      backgroundColor: 'rgba(217, 229, 253, 1)',
      color: `${theme.colors.blue11.value}`,
    },
  }),
);

const JournalList = styled('div', {
  width: '380px',
  height: '217px',
  overflowY: 'auto',
  gap: '6px',
  opacity: '0px',
  paddingTop: 10,
  display: 'flex',
  flexDirection: 'column',
  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-track': {
    background: theme.colors.gray1,
  },
  '&::-webkit-scrollbar-thumb': {
    background: `${theme.colors.gray6}`,
    height: '40px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: theme.colors.gray10,
  },
});
const Heading2 = styled('h1', {
  fontFamily: 'IBM Plex Sans',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '22px',
  textAlign: 'center',
  color: 'rgba(5, 30, 87, 1)',
});
const Heading3 = styled('div', {
  fontFamily: 'IBM Plex Sans',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '22px',
  textAlign: 'center',
  color: 'rgba(5, 30, 87, 1)',
});
const CheckDiv = withOnClickTracking(
  styled('div', {
    position: 'relative',
    width: '100%',
    height: '34px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    cursor: 'pointer',
    color: 'gray',
    borderRadius: 6,
    marginTop: '10px',
    marginBottom: '10px',
    border: `1px solid rgba(188, 199, 220, 1)`,
  }),
);

const Search = styled('input', {
  width: '380px',
  color: theme.colors.gray12,
  gap: '0px',
  outline: 'none',
  border: '2px solid #e6e6e6',
  backgroundColor: theme.colors.white,
  maarginBottom: '0px',
  fontSize: 14,
  background: 'none',
  fontWeight: '400',
  justifyContent: 'flex-start',
  height: 40,
  fontFamily: 'IBM Plex Sans',
  borderRadius: '6px',
  padding: '0.5rem 0.75rem',
});
const DropdownContainer = styled('div', {
  backgroundColor: '#FFF',
  paddingLeft: 0,
  paddingBottom: 0,
  borderRadius: '10px 10px 0 0',
});

const SelectArticleTypeContainer = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

const SelectedOption = styled('div', {
  color: '#0054F1',
  fontFamily: 'IBM Plex Sans',
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '300px',
  '&:hover': {
    color: theme.colors.blue11,
  },
});

const ToggleDropdown = styled('div', {
  cursor: 'pointer',
  color: '#0062FF',
  display: 'flex',
  flexDirection: 'row-reverse',
  paddingLeft: '4px',
  width: 'fit-content',
});
